import { useId } from 'react'
import { useTheme } from '@/contexts/ThemeContext'

interface Props {
  className?: string
  title?: string
}

/**
 * Runna brand mark — Platinum Silver.
 * Dark/dim themes: metallic silver fill with ink details.
 * Light theme: ink fill with silver border + silver R/lines for readability.
 */
export function RunnaMark({ className = '', title = 'Runna' }: Props) {
  const { theme } = useTheme()
  const isLight = theme === 'light'
  const uid = useId().replace(/:/g, '')
  const silverId = `runna-silver-${uid}`
  const inkId = `runna-ink-${uid}`

  return (
    <svg
      className={className}
      viewBox="0 0 48 48"
      fill="none"
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id={silverId} x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#e7eaf2" />
          <stop offset="0.35" stopColor="#b9bfcf" />
          <stop offset="0.55" stopColor="#f0f2f7" />
          <stop offset="0.8" stopColor="#8c93a6" />
          <stop offset="1" stopColor="#d2d6e0" />
        </linearGradient>
        <linearGradient id={inkId} x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#1d2130" />
          <stop offset="1" stopColor="#0d1020" />
        </linearGradient>
      </defs>

      {isLight ? (
        <>
          <rect width="48" height="48" rx="11" fill={`url(#${inkId})`} />
          <rect x="0.5" y="0.5" width="47" height="47" rx="10.5" fill="none" stroke={`url(#${silverId})`} strokeWidth="1" />
          <line x1="4" y1="19" x2="15" y2="19" stroke={`url(#${silverId})`} strokeWidth="3" strokeLinecap="round" />
          <line x1="6" y1="29" x2="15" y2="29" stroke={`url(#${silverId})`} strokeOpacity="0.6" strokeWidth="2.5" strokeLinecap="round" />
          <text
            x="15"
            y="36"
            fontFamily="Inter, system-ui, sans-serif"
            fontWeight="900"
            fontSize="34"
            fill={`url(#${silverId})`}
          >R</text>
        </>
      ) : (
        <>
          <rect width="48" height="48" rx="11" fill={`url(#${silverId})`} />
          <line x1="4" y1="19" x2="15" y2="19" stroke="#1d2030" strokeOpacity="0.35" strokeWidth="3" strokeLinecap="round" />
          <line x1="6" y1="29" x2="15" y2="29" stroke="#1d2030" strokeOpacity="0.2" strokeWidth="2.5" strokeLinecap="round" />
          <text
            x="15"
            y="36"
            fontFamily="Inter, system-ui, sans-serif"
            fontWeight="900"
            fontSize="34"
            fill="#10121c"
          >R</text>
        </>
      )}
    </svg>
  )
}

export default RunnaMark
